/**
 * Maps sidebar path (or path prefix) to backend permission module key.
 * Aligned with new sidebar groups and modules.
 */
export const PATH_TO_MODULE_KEY: Record<string, string> = {
  '/dashboard': 'dashboard',
  '/all-reminders': 'reminders',
  '/todos': 'todos',
  '/todos_monthly_view': 'todos',
  '/crm_tasks': 'crm_tasks',
  '/crm_tasks-monthly': 'crm_tasks',
  '/projects': 'projects',
  '/support-ticket': 'support_ticket',
  '/knowledge-base': 'knowledge_base',
  '/crm_notes': 'crm_notes',
  '/cardboard-crm-notes': 'crm_notes',
  '/client-vault': 'client_vault',
  '/vault-templates': 'vault_templates',
  '/clients': 'clients',
  '/leads': 'leads',
  '/offers': 'offers',
  '/catalog-items': 'catalog_items',
  '/offer-templates': 'offer_templates',
  '/settings/offer-pdf-layouts': 'offer_templates',
  '/calls': 'calls',
  '/appointments': 'appointments',
  '/appointments_calendar_view': 'appointments',
  '/marketing': 'marketing',
  '/client-invoices': 'client_invoices',
  '/invoice-payments': 'invoice_payments',
  '/supplier-invoices': 'supplier_invoices',
  '/suppliers': 'suppliers',
  '/supplier-invoice-payments': 'supplier_payments',
  '/payables': 'payables',
  '/payees': 'payees',
  '/payees-projection': 'payees_projection',
  '/recurring-payables': 'recurring_payables',
  '/expenses': 'expenses',
  '/expenses-summary': 'expenses',
  '/expense-categories': 'expense_categories',
  '/p_crm_expense_category': 'expense_categories',
  '/p_crm_expense_subcategory': 'expense_subcategories',
  '/packages': 'packages',
  '/support-agreements': 'support_agreements',
  '/client-services': 'client_services',
  '/client-services-yearly': 'client_services',
  '/service_renewal_reminders': 'client_services',
  '/task_type': 'task_type',
  '/task_category': 'task_category',
  '/task_status': 'task_status',
  '/priority': 'priority',
  '/ticket_status': 'ticket_status',
  '/call_type': 'call_type',
  '/service_type': 'service_type',
  '/frequency_type': 'frequency_type',
  '/duration': 'duration',
  '/p_crm_service_category': 'service_category',
  '/reminder_type': 'reminder_type',
  '/tax_authority': 'tax_authority',
  '/p_country': 'p_country',
  '/app_status': 'app_status',
  '/p_crm_invoice_category': 'invoice_category',
  '/p_crm_invoice_type': 'invoice_type',
  '/manufacturer': 'manufacturer',
  '/catalog-category': 'catalog_category',
  '/tags': 'tags',
  '/admin/users': 'users',
  '/presets-management': 'presets_management',
  '/settings': 'settings',
  '/admin/module-management': 'module_management',
  '/admin/settings/files-storage': 'deleted_files',
  '/admin/settings/deleted-files': 'deleted_files',
  '/admin/settings/system-email-templates': 'settings',
  '/admin/settings/email-notifications': 'settings',
  '/configuration-settings': 'configuration_settings',
  '/activity-logs': 'activity_logs',
  '/notifications': 'notifications',
  '/workflows': 'workflows',
  '/custom-fields': 'custom_fields',
  '/tools/gemi-preview': 'import_gemi',
  '/tools/11888-preview': 'import_11888',
  '/tools/database-browser': 'database_browser',
  '/import/invoice': 'import_invoice',
  '/reports/ReportGenerator': 'report_generator',
  '/reports/InvoicesByYear': 'reports',
  '/reports/InvoicesPaymentAnalysis': 'reports',
  '/reports/ExpensesByYear': 'reports',
  '/reports/Unpaid': 'reports',
  '/reports/AppointmentsReport': 'reports',
  '/reports/CallsReport': 'reports',
  '/reports/MissedCalls': 'reports',
  '/reports/MonthlyServices': 'reports',
  '/reports/ClientTasksMonthly': 'reports',
  '/reports/TodosMonthlyReport': 'reports',
};

/**
 * Get permission module key for a path. Checks exact match then prefix (e.g. /reports/... -> reports).
 */
export function getModuleKeyForPath(path: string): string | undefined {
  const normalized = path.split('?')[0];
  if (PATH_TO_MODULE_KEY[normalized]) return PATH_TO_MODULE_KEY[normalized];
  const segment = normalized.split('/').filter(Boolean)[0];
  if (!segment) return undefined;
  const byPrefix = Object.entries(PATH_TO_MODULE_KEY).find(
    ([p]) => p.startsWith('/' + segment) || normalized.startsWith(p),
  );
  return byPrefix?.[1];
}
